// extracted by mini-css-extract-plugin
module.exports = {"depositDetails":"_da68288"};